// Test API connectivity and authentication
import { api } from '../services/api';

export async function testApiConnection() {
  console.log("🧪 Testing API Connection...");
  
  try {
    // Test 1: Check if we can get profile
    console.log("1. 📡 Testing getProfile...");
    const profile = await api('/auth/me');
    console.log("✅ Profile response:", profile);
    
    if (profile.ok) {
      console.log("✅ Authentication working, user:", profile.data.email);
      
      // Test 2: Test profile update
      console.log("2. 📝 Testing profile update...");
      const updateData = {
        username: `TestUser_${Date.now()}`,
        contact_number: `+1234567890`,
        image_url: `https://example.com/test_${Date.now()}.jpg`,
        alert_emails: ["test@example.com"]
      };
      
      console.log("📤 Sending update data:", updateData);
      const updateResponse = await api('/auth/update', {
        method: 'PUT',
        body: JSON.stringify(updateData)
      });
      
      console.log("📡 Update response:", updateResponse);
      
      if (updateResponse.ok) {
        console.log("✅ Profile update successful!");
        return { success: true, message: "API connection and profile update working" };
      } else {
        console.error("❌ Profile update failed:", updateResponse.error);
        return { success: false, message: `Profile update failed: ${updateResponse.error}` };
      }
    } else {
      console.error("❌ Authentication failed:", profile.error);
      return { success: false, message: `Authentication failed: ${profile.error}` };
    }
  } catch (error) {
    console.error("❌ API test failed:", error);
    return { success: false, message: `API test failed: ${error.message}` };
  }
}

// Test function that can be called from browser console
window.testApiConnection = testApiConnection;
